import { useState } from "react";
import { Card, Col, Container, Row, Modal, Form, Button } from "react-bootstrap";
import '../css/vacancies.css';

const Vacancies = () => {
    const [showModal, setShowModal] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        tel: '',
        email: ''
    });

    const handleCardClick = (vacancy) => setShowModal(vacancy);
    const handleClose = () => setShowModal(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleApply = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const phoneRegex = /^\+?[78][-(]?\d{3}\)?[-]?\d{3}[-]?\d{2}[-]?\d{2}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.name.trim()) {
            alert('Пожалуйста, введите ваше имя.');
            setIsLoading(false);
            return;
        }
        if (!phoneRegex.test(formData.tel)) {
            alert('Пожалуйста, введите корректный номер телефона.');
            setIsLoading(false);
            return;
        }
        if (!emailRegex.test(formData.email)) {
            alert('Пожалуйста, введите корректный адрес электронной почты.');
            setIsLoading(false);
            return;
        }

        const data = {
            name: formData.name,
            tel: formData.tel,
            email: formData.email,
            type: 'vacancies'
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}api/send-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                alert('Заявка на вакансию успешно отправлена!');
                setShowModal(null);
                setFormData({ name: '', tel: '', email: '' });
            } else {
                alert('Ошибка при отправке заявки.');
            }
        } catch (error) {
            console.error('Ошибка:', error);
            alert('Произошла ошибка при отправке.');
        } finally {
            setIsLoading(false);
        }
    };

    const vacancies = [
        {
            id: 'auto-mechanic',
            title: 'Автослесарь',
            salary: '60,000–200,000 ₽',
            schedule: '5/2, 8 часов',
            experience: 'от 1 года',
            description: 'Мы ищем квалифицированного автослесаря для работы в нашем автосервисе. Вы будете заниматься диагностикой, ремонтом и обслуживанием автомобилей, обеспечивая высокое качество услуг для наших клиентов.',
            requirements: [
                'Опыт работы от 1 года',
                'Знание устройства автомобилей и принципов работы основных систем',
                'Умение проводить диагностику и ремонт',
                'Ответственность, аккуратность, внимательность к деталям'
            ],
            conditions: [
                'Зарплата: от 60,000 до 200,000 ₽',
                'Занятость: Полная',
                'График: 5/2',
                'Рабочие часы: 8 часов в день',
                'Выплаты: 2 раза в месяц'
            ]
        },
        {
            id: 'sales-manager',
            title: 'Менеджер по продажам',
            salary: '50,000–150,000 ₽',
            schedule: '5/2, 8 часов',
            experience: 'от 1 года',
            description: 'Мы ищем энергичного менеджера по продажам для продвижения наших услуг и продуктов. Ваша задача — привлекать новых клиентов, консультировать и заключать сделки, обеспечивая рост продаж компании.',
            requirements: [
                'Опыт работы от 1 года',
                'Навыки активных продаж и ведения переговоров',
                'Коммуникабельность, умение работать с возражениями',
                'Ориентация на результат, инициативность'
            ],
            conditions: [
                'Зарплата: от 50,000 до 150,000 ₽',
                'Занятость: Полная',
                'График: 5/2',
                'Рабочие часы: 8 часов в день',
                'Выплаты: 2 раза в месяц'
            ]
        },
        {
            id: 'auto-painter-bodyworker',
            title: 'Автомаляр-кузовщик',
            salary: '70,000–180,000 ₽',
            schedule: '5/2, 8 часов',
            experience: 'от 1 года',
            description: 'Мы ищем опытного автомаляра-кузовщика для работы в нашем автосервисе. Вы будете заниматься кузовным ремонтом, подготовкой погрузчиков к покраске и нанесением лакокрасочных покрытий для восстановления внешнего вида.',
            requirements: [
                'Опыт работы от 1 года',
                'Знание технологий кузовного ремонта и покраски погрузчиков',
                'Умение работать с покрасочным оборудованием и материалами',
                'Внимательность к деталям, аккуратность, ответственность'
            ],
            conditions: [
                'Зарплата: от 70,000 до 180,000 ₽',
                'Занятость: Полная',
                'График: 5/2',
                'Рабочие часы: 8 часов в день',
                'Выплаты: 2 раза в месяц'
            ]
        }
    ];

    return (
        <Container style={{ maxWidth: 1200 }}>
            <Row className="d-flex justify-content-center mb-5">
                <Col xs={12} md={8}>
                    <h1 className="vacancies_h1">Приглашаем в наш штаб новых сотрудников!</h1>
                </Col>
            </Row>
            <Row xs={1} sm={1} md={2} lg={4} className="d-flex justify-content-center g-4">
                {vacancies.map(vacancy => (
                    <Col key={vacancy.id} className="d-flex justify-content-center">
                        <Card className="vacancies_card" style={{ cursor: 'pointer' }} onClick={() => handleCardClick(vacancy.id)}>
                            <Card.Body>
                                <Card.Title>{vacancy.title}</Card.Title>
                                <Card.Text>
                                    <strong>Зарплата:</strong> {vacancy.salary}<br />
                                    <strong>График:</strong> {vacancy.schedule}<br />
                                    <strong>Опыт:</strong> {vacancy.experience}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            {vacancies.map(vacancy => (
                <Modal key={vacancy.id} show={showModal === vacancy.id} onHide={handleClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{vacancy.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h5>Описание вакансии</h5>
                        <p>{vacancy.description}</p>
                        <h5>Требования:</h5>
                        <ul>
                            {vacancy.requirements.map((req, index) => (
                                <li key={index}>{req}</li>
                            ))}
                        </ul>
                        <h5>Условия:</h5>
                        <ul>
                            {vacancy.conditions.map((condition, index) => (
                                <li key={index}><strong>{condition}</strong></li>
                            ))}
                        </ul>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Ваше имя</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Введите ваше имя"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Ваш телефон</Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="tel"
                                    value={formData.tel}
                                    onChange={handleInputChange}
                                    placeholder="Введите ваш телефон"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Ваша почта</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="Введите вашу почту"
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-between">
                        <Button
                            variant="success"
                            onClick={handleApply}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Загрузка...' : 'Откликнуться на вакансию'}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleClose}
                            disabled={isLoading}
                        >
                            Закрыть
                        </Button>
                    </Modal.Footer>
                </Modal>
            ))}
        </Container>
    );
}

export default Vacancies;